/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkGetCustomerBioDetail} from '../api'

export const useMutationBulkGetCustomerBioDetail = createReactQueryMutationHook('bulkGetCustomerBioDetail', bulkGetCustomerBioDetail)
